import React, { useState } from 'react'
import { Card, Accordion } from 'react-bootstrap'
import PropTypes from 'prop-types'
import DropdownIndicatorIcon from '../select/components/global/DropdownIndicatorIcon';
import classNames from 'classnames';

/**
 * @description Accordion with only one card
 */

const AccordionCard = ({
    title,
    text,
    children
}) => {
    const [activeKey, setActiveKey] = useState(0);

    const toggle = (key) => {
        setActiveKey(prevActiveKey => prevActiveKey === key ? '' : key);
    }

    return (
        <Accordion
            defaultActiveKey={activeKey}
            className={classNames("accordion-card", { active: activeKey === 0 })}
        >
            <Card>
                <DropdownIndicatorIcon status={activeKey !== ''} />
                <Accordion.Toggle
                    as={Card.Header}
                    eventKey={0}
                    onClick={() => toggle(0)}
                >
                    <Card.Title>{title}</Card.Title>
                    <Card.Text>{text}</Card.Text>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={0}>
                    <Card.Body>
                        {children}
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}

export default AccordionCard
